import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cmoMembersList } from '../../../../../containers/actions/pharmaCo/purchaseOrderActions';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import { useStyles } from '../../../grnReceipts/grnStyles';

const CMOFilterMultiSelect = (props) => {
  const { handleSelectCMO, selectedCMOList, filteredCMOList } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [selectedCMOFilter, setSelectedCMOFilters] = useState(selectedCMOList || []);

  const handleCMOFilter = (e) => {
    const value = e.target.value || [];
    setSelectedCMOFilters(value);
  }

  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );

  // Use filtered list from parent if provided, otherwise use full list
  const displayList = filteredCMOList && filteredCMOList.length >= 0
    ? filteredCMOList
    : cmoMemberWithId;

  useEffect(() => {
    setSelectedCMOFilters(selectedCMOList || []);
  }, [selectedCMOList]);

  useEffect(() => {
    let { collabType, ecosystemId, organizationName, roleName } = localStorage;
    dispatch(
      cmoMembersList({
        collabType: collabType,
        roleName: roleName,
        organizationName: organizationName,
        ecosystemId: ecosystemId,
      })
    );
  }, [dispatch]);


  return (
    <FormControl className={classes.formControl} fullWidth>
      <Select
        labelId='cmo-filter-multi'
        id='cmo-filter-multi-id'
        multiple
        value={selectedCMOFilter}
        onChange={handleCMOFilter}
        onClose={() => handleSelectCMO({ target: { value: selectedCMOFilter } })}
        variant='outlined'
        displayEmpty
        renderValue={(selected) =>
          selected.length === 0
            ? 'All'
            : selected.length === displayList.length && displayList.length !== 1
              ? 'All'
              : selected.length === displayList.length && displayList.length === 1
                ? displayList.find(
                  (cmo) => cmo.organization_id === selected[0]
                )?.organization_name || 'All'
                : selected.length === 1
                  ? displayList.find(
                    (cmo) => cmo.organization_id === selected[0]
                  )?.organization_name || 'All'
                  : 'Multiple selection'
        }
        classes={{
          outlined: classes.outlined,
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        <MenuItem value='All'>
          <Checkbox
            checked={
              selectedCMOFilter.length === displayList.length &&
              displayList.length > 0
            }
          />
          <ListItemText primary='All' />
        </MenuItem>
        {displayList.map((cmoMember, i) => (
          <MenuItem key={i} value={cmoMember.organization_id}>
            <Checkbox
              checked={selectedCMOFilter.indexOf(cmoMember.organization_id) > -1}
            />
            <ListItemText primary={cmoMember.organization_name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CMOFilterMultiSelect;
